import { ChangeEvent, useEffect } from "react";
import { Box, Grid, MenuItem } from "@mui/material";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { InputsProductionGerente } from "src/Contexts/ReportProduction/ReportsProductionTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import { ComponentPrivate } from "src/Pages/components/ComponentPrivate/ComponentPrivate";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { DrawerFilterReport } from "src/Pages/components/DrawerFilterReport/DrawerFilterReport";

import { AutoCompleteGerenteReports } from "../../../../../../components/AutoCompleted/AutoCompleteGerenteReports";

import { UseReportProductionGerente } from "../Form/Hooks/UseReportProductionGerente";

export const DrawerFilterProductionGerente = () => {
  const { setActive_incluir, active_incluir } = useConfigPageContext();
  const { handleSubmit } = UseReportProductionGerente();
  const { resetInputs } = useResetInputs(true);
  const { userPerfil } = useAuthContext();

  const { setValuesInputsProductionGerente, valuesInputsProductionGerente } = useContextReportsProduction();

  useEffect(() => setActive_incluir(true), [active_incluir]);

  const handleChange =
    (prop: keyof InputsProductionGerente) =>
      (event: ChangeEvent<HTMLInputElement>) => {
        setValuesInputsProductionGerente({
          ...valuesInputsProductionGerente,
          [prop]: event.target.value,
        });
      };

  return (
    <DrawerFilterReport onClear={resetInputs} onApply={handleSubmit}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          "& .MuiAutocomplete-root": { margin: 0 },
        }}
      >
        <Box>
          <DividerCore title="Período" sxStyle={{ margin: "0 0 16px 0" }} />

          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                label="Data inicial *"
                type="date"
                variant="outlined"
                sxStyle={{ margin: 0 }}
                value={valuesInputsProductionGerente?.start_date}
                onChange={handleChange("start_date")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                label="Data final *"
                type="date"
                variant="outlined"
                sxStyle={{ margin: 0 }}
                value={valuesInputsProductionGerente?.end_date}
                onChange={handleChange("end_date")}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <AppTextField
                fullWidth
                select
                label="Tipo de data *"
                variant="outlined"
                sxStyle={{ margin: 0 }}
                value={valuesInputsProductionGerente?.type_date}
                onChange={handleChange("type_date")}
              >
                <MenuItem value="ASSINATURA">Assinatura</MenuItem>
                <MenuItem value="VIGENCIA">Vigência</MenuItem>
                <MenuItem value="EMISSAO">Emissão</MenuItem>
              </AppTextField>
            </Grid>
          </Grid>
        </Box>

        <ComponentPrivate isView={userPerfil?.type_user !== "PRODUCER"}>
          <Box>
            <DividerCore title="Gerente" sxStyle={{ margin: "0 0 16px 0" }} />
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} sm={4}>
                <AppTextField
                  fullWidth
                  select
                  label="Tipo de relatório"
                  variant="outlined"
                  sxStyle={{ margin: 0 }}
                  value={valuesInputsProductionGerente?.type_report}
                  onChange={handleChange("type_report")}
                >
                  <MenuItem value="ALL">Todos os gerentes</MenuItem>
                  <MenuItem value="UNIQUE">Gerente específico</MenuItem>
                </AppTextField>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                  <AutoCompleteGerenteReports
                    fullWidth
                    disabled={valuesInputsProductionGerente.type_report === "ALL"}
                    label="Selecione o gerente"
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </ComponentPrivate>
      </Box>
    </DrawerFilterReport>
  );
};
